import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Blog } from "src/app/shared/types/blog-types";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";

@Injectable({
  providedIn: "root",
})
export class BlogService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/blogs/${endpoint}`;
  }

  getAllBlogs(): Observable<Blog[]> {
    return this.http.get<Blog[]>(this.apiUrlWithEndpoint(""));
  }

  getBlog(blogId: number): Observable<Blog> {
    return this.http.get<Blog>(this.apiUrlWithEndpoint(`${blogId}`));
  }

  addBlog(blogData: any, files: File[]): Observable<Blog> {
    const formData = new FormData();
    formData.append("title", blogData.title);
    formData.append("content", blogData.content);
    formData.append("categoryId", blogData.categoryId.toString());
    formData.append("languageId", blogData.languageId.toString());
    formData.append("applicationId", blogData.applicationId.toString());
    formData.append("created", blogData.created.toISOString());
    formData.append("updatedAt", blogData.updatedAt.toISOString());
    formData.append("isTutorial", blogData.isTutorial.toString());

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    return this.http.post<Blog>(this.apiUrlWithEndpoint(""), formData);
  }

  updateBlog(blogId: number, blogData: any, files: File[]): Observable<Blog> {
    const formData = new FormData();
    formData.append("id", blogId.toString());
    formData.append("title", blogData.title);
    formData.append("content", blogData.content);
    formData.append("categoryId", blogData.categoryId.toString());
    formData.append("languageId", blogData.languageId.toString());
    formData.append("applicationId", blogData.applicationId.toString());
    formData.append("created", blogData?.created.toString());
    formData.append("updatedAt", blogData.updatedAt.toISOString());
    formData.append("isTutorial", blogData.isTutorial.toString());

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    return this.http.put<Blog>(this.apiUrlWithEndpoint(`${blogId}`), formData);
  }

  deleteBlog(blogId: number): Observable<any> {
    return this.http.delete(this.apiUrlWithEndpoint(`${blogId}`));
  }
}
